import Select, { components } from "react-select";
import { reactSelectStyles } from "../../constants/StyleConstants";
import { days, months, years } from "./socialCalendarConstants";
import { useState } from "react";

const FilterDialog = () => {
  const [startDate, setStartDate] = useState({
    month: months[1],
    day: days[12],
    year: years[15],
  });

  const [endDate, setEndDate] = useState({
    month: months[1],
    day: days[12],
    year: years[15],
  });

  const handleChange = (field, type, value) => {
    if (field === "start") {
      setStartDate((prev) => ({ ...prev, [type]: value }));
    } else {
      setEndDate((prev) => ({ ...prev, [type]: value }));
    }
  };

  return (
    <div className="w-full max-w-md bg-white text-gray-400 rounded-lg p-4">
      <div>
        <p className="text-sm font-medium">Sort by</p>
        <div className="flex gap-2 mt-2">
          <button className="w-1/2 py-2 px-3 text-xs rounded-md border-2 border-gray-200">
            New to Oldest
          </button>
          <button className="w-1/2 py-2 px-3 border-2 text-xs rounded-md border-gray-200">
            Oldest to Newest
          </button>
        </div>
      </div>

      <div className="mt-4">
        <p className="text-sm font-medium">Start Date</p>
        <div className="flex gap-2 mt-2">
          <Select
            options={months}
            value={startDate.month}
            onChange={(value) => handleChange("start", "month", value)}
            className="w-1/3"
            styles={reactSelectStyles}
            placeholder={"Select"}
          />
          <Select
            options={days}
            value={startDate.day}
            onChange={(value) => handleChange("start", "day", value)}
            className="w-1/4"
            styles={reactSelectStyles}
          />
          <Select
            options={years}
            value={startDate.year}
            onChange={(value) => handleChange("start", "year", value)}
            className="w-1/3"
            styles={reactSelectStyles}
          />
        </div>
      </div>

      <div className="mt-4">
        <p className="text-sm font-medium">End Date</p>
        <div className="flex gap-2 mt-2">
          <Select
            options={months}
            value={endDate.month}
            onChange={(value) => handleChange("end", "month", value)}
            className="w-1/3"
            styles={reactSelectStyles}
          />
          <Select
            options={days}
            value={endDate.day}
            onChange={(value) => handleChange("end", "day", value)}
            className="w-1/4"
            styles={reactSelectStyles}
          />
          <Select
            options={years}
            value={endDate.year}
            onChange={(value) => handleChange("end", "year", value)}
            className="w-1/3"
            styles={reactSelectStyles}
          />
        </div>
      </div>

      <div className="mt-6">
        <button className="bg-blue-500 text-white py-2 px-3 rounded-md text-sm font-medium">
          Apply
        </button>
      </div>
    </div>
  );
};
export default FilterDialog;
